<template>
  <footer class="site-footer root box">
    <nav ref="wrapper" class="wrapper page-width">
      <div class="scroller">
        <ul class="nav__list">
          <li
            class="nav__list-item typ__size_sm typ__style_bold typ__style_uppercase typ__tracking_loose"
          >
            <transition name="slide">
              <a
                v-if="appLoaded"
                ref="aboutLink"
                class="nav__list-link active"
                href="#about"
                data-menuanchor="about"
              >About Me</a>
            </transition>
          </li>
          <li
            class="nav__list-item typ__size_sm typ__style_bold typ__style_uppercase typ__tracking_loose"
          >
            <transition name="slide">
              <a
                v-if="appLoaded"
                ref="obsessionLink"
                class="nav__list-link"
                href="#obsession"
                data-menuanchor="obsession"
              >My Obsession</a>
            </transition>
          </li>
          <li
            class="nav__list-item typ__size_sm typ__style_bold typ__style_uppercase typ__tracking_loose"
          >
            <transition name="slide">
              <a
                v-if="appLoaded"
                ref="workLink"
                class="nav__list-link"
                href="#work"
                data-menuanchor="work"
              >My Work</a>
            </transition>
          </li>
          <li
            class="nav__list-item typ__size_sm typ__style_bold typ__style_uppercase typ__tracking_loose"
          >
            <transition name="slide">
              <a
                v-if="appLoaded"
                ref="contactLink"
                class="nav__list-link"
                href="#contact"
                data-menuanchor="contact"
              >Contact Me</a>
            </transition>
          </li>
        </ul>
      </div>
      <small class="copyright-text typ__size_sm">
        <transition name="slide">
          <div v-if="appLoaded">© {{new Date().getFullYear()}} Miguel N. Galace. <span class="copyright-extra">All rights reserved.</span></div>
        </transition>
      </small>
    </nav>
  </footer>
</template>

<script>
import IScroll from 'iscroll'

export default {
  name: 'SiteFooter',
  props: {
    appLoaded: Boolean
  },
  data: function () {
    return {
      iscroll: null,
      iscrollOptions: {
        scrollX: true,
        scrollY: false
      }
    }
  },
  methods: {
    animateLinks: function (origin, destination, direction) {
      const originEl = this.$refs[`${origin.anchor}Link`]
      const destinationEl = this.$refs[`${destination.anchor}Link`]
      const leftClass = 'nav__list-link_left'
      const rightClass = 'nav__list-link_right'

      originEl.classList.remove(leftClass, rightClass)
      destinationEl.classList.remove(leftClass, rightClass)

      if (direction === 'down') {
        originEl.classList.add(rightClass)
        destinationEl.classList.add(leftClass)
      } else {
        originEl.classList.add(leftClass)
        destinationEl.classList.add(rightClass)
      }

      this.scrollToLink(destination)
    },
    scrollToLink: function (destination) {
      const destinationAnchor = this.$refs[`${destination.anchor}Link`]
      this.iscroll.scrollToElement(destinationAnchor, 500, 0, 0, IScroll.utils.ease.quadratic)
    }
  },
  mounted: function () {
    this.$emit('animationCallbackReady', this.animateLinks)

    this.$nextTick(function () {
      this.iscroll = new IScroll(this.$refs.wrapper, this.iscrollOptions)
    })
  }
}
</script>

<style scoped lang="scss">
.root {
  font-size: 1rem;
}

.box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: $sz__site-footer-height;
  background: $clr__bg;
}

.wrapper {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  height: 100%;
  overflow: hidden;
}

.scroller {
  float: left;
  margin-bottom: 0.25em;
}

.nav__list {
  white-space: nowrap;

  &-item {
    position: relative;
    display: inline-block;
    margin-right: calc-interpolation(getEm($sz__site-min-width), 1em, getEm($sz__site-max-width), 5em);
    vertical-align: top;
    overflow: hidden;

    &.active {
      color: $clr__body-dark;
    }
  }

  &-link {
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
    transition: color $tm__slow-animation $tm__ease-in-out-quint;
    will-change: transform;
  }

  &-link:after {
    display: block;
    position: absolute;
    bottom: .2em;
    width: 100%;
    height: 2px;
    background: $clr__body-dark;
    transform: scaleX(0);
    will-change: transform;
    transition: transform $tm__slow-animation $tm__ease-in-out-quint $tm__slow-animation;
    content: "";
  }

  &-link_left:after {
    transform-origin: left;
  }

  &-link_right:after {
    transform-origin: right;
  }

  &-link.active:after {
    transform: scaleX(1);
    transition: transform $tm__slow-animation $tm__ease-in-out-quint;
    transition-delay: 0;
  }

  &-item.active .nav__list-link {
    color: $clr__body-dark;
  }
}

.copyright-text {
  overflow: hidden;
}

.copyright-extra {
  display: none;
}

@include md-screen {
  .scroller {
    margin-bottom: unset;
  }

  .nav__list-item:after {
    height: 3px;
  }

  .wrapper {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .copyright-extra {
    display: unset;
  }
}

/* * * * * * * * * *
* TRANSITIONS
*/

.slide-enter-active {
  transition: transform $tm__intro-animation $tm__ease-in-out-quint;
}

.slide-enter {
  transform: translateX(-100%);
}
</style>
